import React, { Component } from 'react';

class Video extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  playVideo = () => {
    if (this.video && this.video.srcObject) {
      this.video.play().catch(e => {
       
        console.log('Video Autoplay blocked :', e.message)
      })
    }
  }

  componentDidMount() {
    if (this.props.videoStream) {
      this.video.srcObject = this.props.videoStream
      this.playVideo()
    }
  }

  componentDidUpdate(prevProps) {
    console.log('[Video] componentDidUpdate, stream:', this.props.videoStream?.id)

    if (this.props.videoStream && this.props.videoStream !== prevProps.videoStream) {
      this.video.srcObject = this.props.videoStream
      this.playVideo()
    }
  }

  render() {
    return (
      <div
        style={{ ...this.props.frameStyle }}
      >
        <video
          id={this.props.id}
          muted={this.props.muted}
          autoPlay
          playsInline
          style={{ ...this.props.videoStyles }}
          ref={ (ref) => {this.video = ref }}
        ></video>
      </div>
    )
  }
}

export default Video